import React, { useEffect, useState } from "react";
import { Mail } from "lucide-react";
import api from "@/lib/api";
import AdminLayout from "@/components/admin/AdminLayout";
import { formatDate, formatTime } from "@/lib/constants";

export default function AdminContacts() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => { api.get("/admin/contacts").then((r) => setItems(r.data.items)).catch(() => {}).finally(() => setLoading(false)); }, []);

  return (
    <AdminLayout title="Mensajes de contacto">
      {loading ? <p className="text-gray-400">Cargando…</p> : items.length === 0 ? (
        <div className="text-center py-20 text-gray-400"><Mail size={40} className="mx-auto mb-3" /><p>No hay mensajes todavía.</p></div>
      ) : (
        <div className="space-y-4" data-testid="admin-contacts-list">
          {items.map((c) => (
            <div key={c.id} className="bg-white rounded-lg border border-gray-200 p-5" data-testid={`contact-${c.id}`}>
              <div className="flex items-start justify-between flex-wrap gap-2">
                <div>
                  <p className="font-bold text-nx-dark">{c.nombre} {c.apellido}</p>
                  <p className="text-sm text-gray-500">{c.email}{c.telefono && ` · ${c.telefono}`}{c.organizacion && ` · ${c.organizacion}`}</p>
                </div>
                <div className="text-right">
                  <span className="text-[11px] font-bold uppercase bg-nx-blue/10 text-nx-blue px-2 py-1 rounded">{c.motivo}</span>
                  <p className="text-xs text-gray-400 mt-1">{formatDate(c.created_at)}, {formatTime(c.created_at)}</p>
                </div>
              </div>
              <p className="mt-3 font-semibold text-sm text-nx-dark">{c.asunto}</p>
              <p className="mt-1 text-sm text-gray-600 whitespace-pre-line">{c.mensaje}</p>
            </div>
          ))}
        </div>
      )}
    </AdminLayout>
  );
}
